import { DataSetWiki } from 'src/types/cohorts';

interface CohortData {
  name?: string;
  description?: string;
  createdBy?: string;
  createdAt?: string;
  dataWiki?: DataSetWiki;
}

interface InfoSectionProps {
  label: string;
  children: React.ReactNode;
}

interface DateRange {
  min_date: string;
  max_date: string;
}
interface TimelineInfoProps {
  data: CohortData | null;
}

const Divider = () => {
  return <div className="w-px bg-gray-800 h-[46px] max-md:hidden" aria-hidden="true" />;
};

const InfoSection: React.FC<InfoSectionProps> = ({ label, children }) => {
  return (
    <section className="flex flex-col gap-1 items-start">
      <h2 className="text-sm font-semibold leading-5 text-gray-400 max-sm:text-xs">{label}</h2>
      <p className="text-base leading-6 text-gray-100 max-sm:text-sm">{children}</p>
    </section>
  );
};
export const TimelineInfo = ({ data }: TimelineInfoProps) => {
  const formatDateRange = (dateRange: DateRange | string | undefined): string => {
    if (!dateRange) return 'N/A';
    if (typeof dateRange === 'string') return dateRange;

    const { min_date, max_date } = dateRange;
    if (!min_date || !max_date) return 'N/A';

    const formatDate = (dateString: string): string => {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    };

    return `${formatDate(min_date)} - ${formatDate(max_date)}`;
  };

  const formatCreatedAt = (dateString: string | undefined): string => {
    if (!dateString) return 'N/A';

    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <article className="flex gap-4 items-center p-4 mx-auto max-w-none bg-transparent rounded-md border border-stroke-on-dark-subdued border-solid max-md:flex-col max-md:items-start max-md:max-w-[991px] max-sm:p-3 max-sm:max-w-screen-sm">
      <InfoSection label="Time span">
        {formatDateRange(data?.dataWiki?.metadata?.date_range)}
      </InfoSection>

      <Divider />

      <InfoSection label="Created at">{formatCreatedAt(data?.createdAt)}</InfoSection>

      <Divider />

      <InfoSection label="Data provider">
        <span>{data?.dataWiki?.metadata?.provider_name || 'N/A'} </span>
        {data?.dataWiki?.metadata?.provider_name && (
          <button
            className="text-cyan-300 hover:underline focus:outline-none focus:ring-2 focus:ring-cyan-300 focus:ring-offset-2 rounded"
            onClick={() => {
              /* Handle learn more click */
            }}
          >
            Learn more
          </button>
        )}
      </InfoSection>
    </article>
  );
};
